<template>
  <div class="free">
    <div class="EC5 free-title" v-html="title"></div>
    <div v-if="desc" class="free-subtitle">{{ desc }}</div>
    <div class="btn-group">
      <a target="_blank" class="btn2 btn-effect" :href="href">{{
        btnText || '立即创建体验'
      }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    href: String,
    desc: String,
    btnText: String
  }
};
</script>

<style>
</style>
